"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mergeClassNames;

function mergeClassNames() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (classList, arg) {
    return typeof arg === 'string' || arg instanceof Array ? classList.concat(arg) : classList;
  }, []).filter(Boolean).join(' ');
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/merge-class-names/dist/entry.js
 ** module id = 237
 ** module chunks = 0
 **/